const comparisonOperator = {
  match: [
    '!=',
    '*=',
    '>=',
    '<=',
    '>',
    '<',
    '=',
  ],
}

export default comparisonOperator
